import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import {
  Autocomplete,
  Avatar,
  CircularProgress,
  ListItemAvatar,
  ListItemText,
  TextField,
  Grid,
  Card,
  Box,
  List,
  ListItem,
} from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { addAlert, useMaterialUIController, useAuth, setCurrentDialog } from "context";
import MDInput from "components/MDInput";
import { TablePage } from "components/alove/TablePage";
import { PermissionType } from "models/BO/BoRole";
import { AddNewLanguageModal } from "./components/addNewLanguageModal";
import { publishLangsList, translationsLanguagesDO,  translateLanguageDO, updateLanguageDO } from "utils/translateUtils";
import languages from "./components/languaesList.json";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { PageNumber } from "../../accessNumbers";
import TranslateIcon from "@mui/icons-material/Translate";
import { DialogType } from "components/alove/AloveDialog";

const host = "dev";

const shouldColorBackground = (request) =>
  request.status <= 9 &&
  (request.statusReason?.initiatorStatus || request.statusReason?.responderStatus);

const action = (request, refresh) => {};

function LanguageSettings() {
  const pageNumber = PageNumber.LangTranslations;
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = useAuth();
  const isAdmin = currentRole?.hasAccess(pageNumber, PermissionType.Manager);
  const navigate = useNavigate();

  const [topics, setTopics] = useState([]);
  const [choosenBrand, setChoosenBrand] = useState(null);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [newLangs, setNewLangs] = useState({} as any);

  const handleTranslate = async (langCode: string) => {
    try {
      await translateLanguageDO(langCode);
      addAlert(dispatch, "Translation started", true);
    } catch (error) {
      addAlert(dispatch, "Failed to start translation", true);
    }
  };

  const getSettings = async (filters, page) => {
    const langs = await translationsLanguagesDO();
    const totalCount = langs[0].count || 1
    langs.forEach((item) => {
      const count = item.count;
      item.percentage = ((count / totalCount) * 100).toFixed(2) + "%";
    });

    const existsLangCodes = new Set(langs.map((lang) => lang.code));
    const updatedLangs = languages.filter((lang) => !existsLangCodes.has(lang.code));
    setNewLangs(updatedLangs);
    return langs;
  };

  const SLAcolumns = (isAdmin, action): any => [
    {
      headerName: "Language",
      field: "name",
      width: 200,
    },
    {
      headerName: "Words",
      field: "count",
      width: 150,
    },
    {
      headerName: "% translated",
      field: "percentage",
      width: 150,
    },
    {
      field: "isCompleted",
      headerName: "Display",
      width: 150,
      type: "boolean",
      align: "center",
      // hidden: (params) => !currentRole?.hasAccess(pageNumber, PermissionType.Manager),
      editable: true,
    },
    {
      field: "localName",
      headerName: "Local name",

    },
    {
      field: 'flag',
      headerName: 'Flag',
    },
    {
      field: 'rtl',
      headerName: 'RTL',
      type: 'boolean'
    
    },{
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      type: 'actions',
      getActions: (params) => [
        <GridActionsCellItem
          icon={<TranslateIcon />}
          label="Translate"
          onClick={() => handleTranslate(params.row.code)}
          color="primary"
        />
      ],
    }
  ];

  const processRowUpdate = async (newRow) => {
    
     const updateStatus = await updateLanguageDO(newRow?.id, {isCompleted: newRow?.isCompleted});
    addAlert(dispatch, "Status was updated");
    return newRow;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Languages" />
      <Box
        sx={{
          "& .urgent": {
            color: "#F4357A",
          },
          "& .hidden": {
            color: "transparent !important",
          },
        }}
      >
        <TablePage
          title="Languages"
          refresh={refresh}
          // onCellClick={(params, events) => {
          //   ;
          //   ;
          // }}
          actions={{
            page: pageNumber,
            addActions: [
              {
                role: PermissionType.AddNew,
                label: "Language",
                variant: "contained",
                onClick: () => setCurrentDialog(dispatch, DialogType.AddNewLanguage),
              },
            ],
            saveActions: [
              {
                role: PermissionType.Publish,
                label: "Publish",
                onClick: () => publishLangsList().then(() => addAlert(dispatch, "Languages were published")),
                variant: "contained",
              },
            ],
          }}
          table={{
            columns: SLAcolumns(isAdmin, action),
            loadNext: getSettings,
            pagination: true,
            processRowUpdate: processRowUpdate,
            lineClick: (row) => {
              navigate(`/translations_list/${row?.row?.code}`);
            },
          }}
        />
      </Box>
      <AddNewLanguageModal refresh={() => setRefresh(!refresh)} />
    </DashboardLayout>
  );
}

export default LanguageSettings;
